import { MapApp } from "@services/API/MapData";
import { apiCall } from "@services/API/Requests";
import { handleResponse } from "@services/API/StatusCodes";
import { TranslateErrorMessage } from "@services/ErrorHandling";

export const getAppData = async (
  setAppData: (data: any) => void,
  setError: (error: any) => void,
  setLoading: (loading: boolean) => void,
) => {
  return apiCall({
    method: "get",
    url: `v1/apps/`,
    setLoading,
    onSuccess: (response) => {
      const apps = response.data.map(MapApp);
      setAppData(apps);
      const responseMessage = handleResponse(response, "ユーザアップ");
      return responseMessage;
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(TranslateErrorMessage(error));
    },
  });
};
